export default __webpack_public_path__ + "static/media/epcimage.d6369f1a.png";